<!--
 * @FileDescription: 公共菜单（注释描述）
 * @Author: ryb（作者）
 * @Date: 2020-04-13（时间）
 * @LastEditors: ryb（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
    <div class="public-left-menu" :style="{height:menuHeight+'px'}" v-clickoutside:[classList]="closeIconBlock">
        <div class="level-one-menu">
            <div v-for="(item,index) in menuList" :key="index" :class="getclass(item.meta.icon)">
                <div :class="oneNum==index?'one-menu one-menu-open' :'one-menu'" @click="choiceMenus(index)">
                    <span :style="{backgroundImage:oneNum==index?'url('+getImageUrl(item.meta.icon,1)+')' :'url('+getImageUrl(item.meta.icon,2)+')'}" class="menu-icon-image"></span>
                    <span style="padding-top: 12px">{{ item.meta.title }}</span>
                </div>
            </div>
        </div>
        <div :class="isPackUp?'else-menu-up' :'else-menu'">
            <a-menu mode="inline" theme="dark" :openKeys="openKeys" v-model="selectedKeys" @openChange="onOpenChange">
                <a-sub-menu v-for="(item) in childrenMenu" :key="item.id" :class="detectionPath(item.path)?'two-menu-path' :''">
                    <span slot="title" @click="openTwoMenu(item)">{{ item.meta.title }}</span>
                    <!--<div slot="title"-->
                    <!--class="two-title">-->
                    <!--<span class="title">{{ item.meta.title }}</span>-->
                    <!--<span class="image"-->
                    <!--v-if="item.children"></span>-->
                    <!--</div>-->
                    <a-menu-item v-for="(ite) in getThreeNum(item.children)" :key="ite.id" @click="openMenu(ite)" style="padding-left: 32px">{{ ite.meta.title }}</a-menu-item>
                </a-sub-menu>
            </a-menu>
        </div>
        <!-- <div class="pack-up"
             @click="btnPackUp">
          <a-icon :type="isPackUp?'double-right' :'double-left'" :class="isPackUp ? 'pack-up-icon' : 'pack-up-icon1'" />
        </div> -->
    </div>
</template>
<script>
    export default {
        name: "publicleft",
        data () {
            return {
                oneNum: 0,
                menuList: [],
                childrenMenu: [],
                openKeys: [],
                rootSubmenuKeys: [],
                selectedKeys: [],
                isPackUp: true,
                classList: [],
                menuHeight: null,
            }
        },
        computed: {
            getThreeNum () {
                return function (data) {
                    return data.filter(function (item) {
                        return item.meta.route_flag == 1 ? true : false
                    })
                }
            }
        },
        mounted () {
            this.init()
        },
        methods: {
            /**
             * @description: 初始化数据（方法描述）
             * @param {参数类型} 参数名称
             * @return void
             */
            init () {
                this.oneNum = sessionStorage.getItem('oneMenuNum')
                this.menuList = this.$store.state.menuList
                this.childrenMenu = this.menuList[this.oneNum].children
                this.$store.state.menuId ? this.selectedKeys.push(this.$store.state.menuId) : this.selectedKeys = []
                // 获取可视区域高度
                this.menuHeight = document.body.scrollHeight - 54
                //  是否隐藏二级菜单
                this.isPackUp = this.$store.state.isPackUp
                // 获取当前窗口高度
                const that = this;
                window.onresize = () => {
                    return (() => {
                        that.menuHeight = window.innerHeight - 54
                    })()
                }
            },
            getImageUrl (icon, type) {
                if (type == 1) {
                    return require('@/assets/menu/1' + icon)
                } else {
                    return require('@/assets/menu/' + icon)
                }
            },
            // 获取class名称
            getclass(icon) {
                return icon.split(".")[0]
            },
            /**
             * @description: 检测是否是二级跳转路由菜单（方法描述）
             * @param {Array} openKeys
             * @return void
             */
            detectionPath (path) {
                let status = false
                this.$store.state.twoMenuPath.map(item => {
                    if (path == item) {
                        status = true
                    }
                })
                return status
            },
            /**
             * @description: 展开二级菜单（方法描述）
             * @param {Array} openKeys
             * @return void
             */
            onOpenChange (openKeys) {
                const latestOpenKey = openKeys.find(key => this.openKeys.indexOf(key) === -1);
                if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
                    this.openKeys = openKeys;
                } else {
                    this.openKeys = latestOpenKey ? [latestOpenKey] : [];
                }
            },
            /**
             * @description: 选择菜单（方法描述）
             * @param {Number} index：一级菜单下标
             * @return void
             */
            choiceMenus (index) {
                this.oneNum = index
                this.childrenMenu = this.menuList[index].children
                this.isPackUp = false
                this.$store.state.isPackUp = this.isPackUp
            },
            /**
             * @description: 打开菜单（方法描述）
             * @param {Object} ite：菜单信息
             * @return void
             */
            openMenu (ite) {
                // if (this.$store.state.menuId != ite.id) {
                //     this.$router.push({ path: ite.path })
                //     this.$store.state.menuId = ite.id
                //     sessionStorage.setItem('oneMenuNum', this.oneNum)
                // }
                console.log(ite.path)
                this.$router.push({ path: ite.path })
                this.$store.state.menuId = ite.id
                sessionStorage.setItem('oneMenuNum', this.oneNum)
                this.isPackUp = true
                this.$store.state.isPackUp = this.isPackUp
                this.$store.state.loadFailed = false
            },
            openTwoMenu (ite) {
                if(ite.path=='/sales/guidance/salesGuidance') {
                    this.$router.push({ path: ite.path })
                    this.$store.state.menuId = ite.id
                } else if(ite.path=='/purchase/purchaseguide/purchaseGuidance') {
                    this.$router.push({ path: ite.path })
                    this.$store.state.menuId = ite.id
                } else if(ite.path=='/librarymanage/guide/libraryManage') {
                    this.$router.push({ path: ite.path })
                    this.$store.state.menuId = ite.id
                }
                sessionStorage.setItem('oneMenuNum', this.oneNum)
                this.isPackUp = true
                this.$store.state.isPackUp = this.isPackUp
                this.$store.state.loadFailed = false
            },
            /**
             * @description: 是否收起二级菜单
             * @param {参数类型} 参数名称
             * @return void
             */
            // btnPackUp () {
            //   this.isPackUp = !this.isPackUp
            //   this.$store.state.isPackUp = this.isPackUp
            // },
            // 获取隐藏菜单路由id
            getHideId (menuList) {
                menuList.map((oneLevel, oneNum) => {
                    oneLevel.children.map((twoLevel, twoNum) => {
                        twoLevel.children.map((threeLevel, threeNum) => {
                            if (this.$store.state.selectMenu.threeTitle == threeLevel.meta.title) {
                                this.selectedKeys.push(threeLevel.id)
                            }
                        })
                    })
                })
            },
            // 点击外部收起二级菜单
            closeIconBlock () {
                this.isPackUp = true
                this.$store.state.isPackUp = true
            }
        },
        watch: {
            childrenMenu () {
                this.openKeys = []
                this.childrenMenu.map(item => {
                    this.openKeys.push(item.id)
                })
            },
            $route: {
                handler: function () {
                    let path = this.$route.path
                    this.menuList.map((oneLevel, oneNum) => {
                        if (path != oneLevel.path) {
                            oneLevel.children.map((twoLevel, twoNum) => {
                                if (path != twoLevel.path) {
                                    twoLevel.children.map((threeLevel, threeNum) => {
                                        if (path == threeLevel.path) {
                                            if (threeLevel.meta.route_flag == 1) {
                                                this.selectedKeys = []
                                                this.choiceMenus(oneNum)
                                                this.$store.state.menuId = threeLevel.id
                                                this.selectedKeys.push(this.$store.state.menuId)
                                            } else {
                                                if (this.$comm.getIsPath(threeLevel.name)) {
                                                    this.selectedKeys = []
                                                    this.choiceMenus(oneNum)
                                                    this.$store.state.menuId = threeLevel.id
                                                } else {
                                                    this.getHideId(this.$store.state.menuList)
                                                }
                                            }
                                        }
                                    })
                                }
                            })
                        }
                    })
                    // 跳转路由关闭二级框
                    this.isPackUp = true
                    this.$store.state.isPackUp = this.isPackUp
                },
                // 深度观察监听
                deep: true
            },
        },
    }
</script>
<style lang="scss">
    .public-left-menu {
        position: relative;
        text-align: center;
        color: rgba(255, 255, 255, 0.5);
        font-size: 20px;
        display: flex;
        height: 100%;
        .level-one-menu {
            width: 90px;
            height: 100%;
            padding: 15px 12px;
            background-color: #1b1816;
            overflow: auto;
            z-index: 100;
            //   处理滑动样式
            &::-webkit-scrollbar {
                height: 5px;
                width: 0px;
                overflow-y: auto;
            }

            &::-webkit-scrollbar-thumb {
                border-radius: 5px;
                -webkit-box-shadow: inset 0 0 5px rgba(89, 89, 89, 0.2);
                background: #939392;
            }

            &::-webkit-scrollbar-track {
                -webkit-box-shadow: 0;
                border-radius: 0;
                background: #f0f2f5;
            }
            .one-menu {
                height: 93px;
                font-size: 14px;
                cursor: pointer;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                border-bottom: 1px solid rgba(255, 255, 255, 0.06);
                color: rgba(255, 255, 255, 0.5);
                .anticon {
                    padding-bottom: 13px;
                }
            }
            .one-menu:hover {
                opacity: 0.9;
                color: var(--co);
            }

            .danju:hover .menu-icon-image {
                background-image: url("../../assets/menu/1danju.png") !important;
            }
            .shangpin:hover .menu-icon-image {
                background-image: url("../../assets/menu/1shangpin.png") !important;
            }
            .kucun:hover .menu-icon-image {
                background-image: url("../../assets/menu/1kucun.png") !important;
            }
            .xiaohuo:hover .menu-icon-image {
                background-image: url("../../assets/menu/1xiaohuo.png") !important;
            }
            .caigou:hover .menu-icon-image {
                background-image: url("../../assets/menu/1caigou.png") !important;
            }
            .caiwu:hover .menu-icon-image {
                background-image: url("../../assets/menu/1caiwu.png") !important;
            }
            .tongji:hover .menu-icon-image {
                background-image: url("../../assets/menu/1tongji.png") !important;
            }
            .ziliao:hover .menu-icon-image {
                background-image: url("../../assets/menu/1ziliao.png") !important;
            }
            .ziliao:hover .menu-icon-image {
                background-image: url("../../assets/menu/1ziliao.png") !important;
            }

            .menu-icon-image {
                display: inline-block;
                width: 22px;
                height: 22px;
                background-size: 100% auto;
            }

            .one-menu-open {
                opacity: 0.9;
                color: var(--co);
            }
            .icon-image {
                width: 22px;
            }
        }
        .else-menu,
        .else-menu-up {
            height: 100%;
            overflow: auto;
            background: rgba(249, 249, 249, 1);
            box-shadow: 4px 0px 14px 0px rgba(114, 114, 114, 0.1);
            .ant-menu {
                background: #f9f9f9;
                color: #333333;
                font-size: 14px;
            }
            .ant-menu-submenu-title {
                height: 46px;
                line-height: 46px;
                text-align: left;
                font-size: 14px;
                font-weight: 700;
                /*color: #333333;*/
                .ant-menu-submenu-arrow {
                    height: 10px;
                }
                .ant-menu-submenu-arrow::before,
                .ant-menu-submenu-arrow::after {
                    background: #888888 !important;
                }
            }
            .ant-menu-submenu-open {
                color: #333333;
            }
            .ant-menu-submenu-title:hover {
                color: var(--co);
                .ant-menu-submenu-arrow::before,
                .ant-menu-submenu-arrow::after {
                    background: var(--co) !important;
                }
            }
            .ant-menu-submenu-selected {
                color: var(--co);
                .ant-menu-submenu-arrow::before,
                .ant-menu-submenu-arrow::after {
                    background: var(--co) !important;
                }
            }
            .ant-menu-item {
                background-color: #f9f9f9;
                margin: 0;
                height: 44px;
                line-height: 44px;
                text-align: left;
                border-left: 4px solid #f9f9f9;
                color: #333333;
                font-size: 14px;
            }
            .ant-menu-item:hover {
                color: var(--co);
                background-color: #f9f9f9;
            }
            .ant-menu-item-selected {
                border-left: 4px solid;
                background-color: #dddddd !important;
                border-color: var(--co);
            }
        }
        // .else-menu {
        //     width: 154px;
        //     transition: 0.3s;
        //     padding-bottom: 30px;
        //     &::-webkit-scrollbar {
        //         height: 5px;
        //         width: 0px;
        //         overflow-y: auto;
        //     }

        //     &::-webkit-scrollbar-thumb {
        //         border-radius: 5px;
        //         -webkit-box-shadow: inset 0 0 5px rgba(89, 89, 89, 0.2);
        //         background: #939392;
        //     }

        //     &::-webkit-scrollbar-track {
        //         -webkit-box-shadow: 0;
        //         border-radius: 0;
        //         background: #f0f2f5;
        //     }
        // }
        // .else-menu-up {
        //     width: 0;
        //     transition: 0.3s;
        // }
        .else-menu {
            min-width: 154px;
            transition: 0.3s;
            padding-bottom: 30px;
            position: absolute;
            top: 0;
            left: 90px;
            height: 100%;
            z-index: 10;
            -moz-box-shadow:0 0 5px 5px rgba(89, 89, 89, 0.2);
            -webkit-box-shadow:0 0 5px 5px rgba(89, 89, 89, 0.2);
            box-shadow:0 0 5px 5px rgba(89, 89, 89, 0.2);
        }
        .else-menu-up {
            min-width: 154px;
            transition: 0.3s;
            padding-bottom: 30px;
            position: absolute;
            top: 0;
            left: -154px;
            height: 100%;
            z-index: 10;
            -moz-box-shadow:0 0 5px 5px rgba(89, 89, 89, 0.2);
            -webkit-box-shadow:0 0 5px 5px rgba(89, 89, 89, 0.2);
            box-shadow:0 0 5px 5px rgba(89, 89, 89, 0.2);
        }
        .two-menu-path {
            padding-top: 20px;
            .ant-menu-submenu-arrow {
                display: none;
            }
            .ant-menu-submenu-title {
                height: 26px;
                line-height: 26px;
            }
        }
        //   .pack-up {
        //     position: absolute;
        //     top: 20%;
        //     right: 0;
        //     width: 14px;
        //     height: 40px;
        //     background:rgba(170,170,170,0.3);
        //     font-size: 12px;
        //     line-height: 40px;
        //     text-align: center;
        //     cursor: pointer;
        //     .pack-up-icon{
        //         color: rgba(255,255,255,0.3);
        //     }
        //     .pack-up-icon1{
        //         color: #999999;
        //     }
        //   }
    }
</style>
